import React, { useState } from "react";
import { toFeetInches } from "../lib/Utils";

const LockerModalContent = ({ lockerInfos }) => {
    const [selectedSlot, setSelectedSlot] = useState(
        lockerInfos?.bookingSlots?.[0] || null
    );

    const convertToInch = (width, depth, height) => {
        if (!width || !depth || !height) return "";

        const w = toFeetInches(width);
        const d = toFeetInches(depth);
        const h = toFeetInches(height);

        return `${w} W x ${d} D x ${h} H`;
    };
    if (!lockerInfos) {
        return <div>No Data Available</div>;
    }
    console.log("lockerInfos : ", lockerInfos);
    console.log("selected slot data is: ", selectedSlot);

    return (
        <div className="locker-modal">
            <h2 className="modal-title">Choose Your Locker</h2>
            <div className="locker-header">
                <div className="locker-left">
                    <div className="locker-icon">
                        {lockerInfos?.code || "Nan"}
                    </div>
                    <div className="locker-info">
                        <div className="locker-name">Dimensions</div>
                        <div className="locker-dimension-wrapper">
                            <div className="locker-dimension">
                                {convertToInch(
                                    lockerInfos?.width,
                                    lockerInfos?.depth,
                                    lockerInfos?.height
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="slot-header">
                <p>Choose duration slots of the booking</p>
            </div>
            <div className="slot-list">
                {lockerInfos?.bookingSlots?.map((slot) => (
                    <label
                        key={slot.id}
                        className={`slot ${
                            selectedSlot?.id === slot.id ? "active" : ""
                        }`}
                    >
                        <div className="left">
                            <input
                                type="radio"
                                name="slot"
                                checked={selectedSlot?.id === slot.id}
                                onChange={() => setSelectedSlot(slot)}
                            />
                            <span className="slot-label">
                                {slot.durationRange}
                            </span>
                        </div>

                        <div className="price">
                            {lockerInfos?.currency} {slot.price}
                        </div>
                    </label>
                ))}
            </div>
            <div className="total-cost">
                <span>Total Cost</span>

                <div className="amount-box">
                    <span className="currency">
                        ({lockerInfos?.currency})
                    </span>
                    <span className="amount">
                        {selectedSlot?.price || 0}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LockerModalContent;